import BaseUI from "../../../core/src/ui/BaseUI";
import { UIStates, UIModes } from "../../../core/src/ui/UIStates";
import ViewManager from "../../../core/src/utils/ViewManager";
import { DefaultLayers } from "../../../core/src/utils/Layers";
import { UIButtons } from "../../../core/src/ui/UIButtons";
import { Commands } from "../../../core/src/commands/CommandEnum";
import { UIUpdateEvent } from "../../../core/src/ui/UIUpdateEvents";
import { UIComponents } from "../../../core/src/ui/UIComponents";
import SpinModel from "../../../core/src/model/SpinModel";
import BetModel from "../../../core/src/model/BetModel";
import SoundVars from "../../../core/src/const/SoundVars";
import TextField from "../../../core/src/views/components/TextField";
import AutoplayModel from "../../../core/src/model/AutoplayModel";
import BangUp from "../../../core/src/utils/BangUp";
import GameModel from "../../../core/src/model/GameModel";
import PromotionalFreeGamesModel from "../../model/PromotionalFreeGamesModel";
import { VendorCommandsEnum } from "../../commands/VendorCommandsEnum";
import CommandManager from "../../../core/src/commands/CommandManager";
import JackpotsModel from "../../model/JackpotsModel";
import Configs from "../../vendorConfigs/Configs";
import App from "../../../core/src/App";
// import VendorModel from "../../../server/model/VendorModel";

export default class UIDesktop extends BaseUI {
    protected autoSpinCounts: TextField;
    public create(): void {
        super.create();
        this.scene = ViewManager.getLayer(DefaultLayers.BetBar).setScene();
        this.scene.buttons.forEach((btn) => {
            this.buttons.push(btn);
            this.elements.push(btn);
        });
        this.autoSpinCounts = this.scene.sceneTextFields.get(
            "autoCount"
        ) as TextField;
        this.assignInterraction(
            Commands.SPIN,
            this.scene.buttons.get(UIButtons.Spin)
        );
        this.assignInterraction(
            Commands.STOP_AUTOPLAY,
            this.scene.buttons.get(UIButtons.StopAutoplay),
            SoundVars.BUTTON_CLICK
        );
        if (!GameModel.gameConfig.disableAutoplay) {
            this.assignInterraction(
                Commands.TOGGLE_AUTOPLAY_SETTINGS,
                this.scene.buttons.get(UIButtons.AutoPlay),
                SoundVars.BUTTON_CLICK
            );
        }
        if (Configs.game?.buyFeature?.isActivated) {
            this.assignInterraction(
                Commands.TOGGLE_BUY_FEATURE,
                this.scene.buttons.get(UIButtons.FeatureBuy),
                SoundVars.BUTTON_CLICK
            );
        }
        //    this.assignInterraction(Commands.TOGGLES_S, this.scene.buttons.get(UIButtons.StopAutoplay), SoundVars.BUTTON_CLICK);
        this.assignInterraction(
            Commands.TOGGLE_SETTINGS,
            this.scene.buttons.get(UIButtons.Settings),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            [
                Commands.TOGGLE_MASTER_SOUND,
                VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
            ],
            this.scene.buttons.get(UIButtons.SoundMuted),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            [
                Commands.TOGGLE_MASTER_SOUND,
                VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
            ],
            this.scene.buttons.get(UIButtons.Sound),
            SoundVars.BUTTON_CLICK
        );
        this.assignInterraction(
            Commands.TOGGLE_BET_SETTINGS,
            this.scene.buttons.get(UIButtons.Bet),
            SoundVars.BUTTON_CLICK
        );
        if (GameModel.canSkipSpin()) {
            this.assignInterraction(
                Commands.SKIP,
                this.scene.buttons.get(UIButtons.Stop)
            );
        }
        if (this.scene.buttons.has(UIButtons.Turbo)) {
            this.assignInterraction(
                Commands.TOGGLE_TURBO_SPIN,
                this.scene.buttons.get(UIButtons.Turbo)
            );
        }
        if (this.scene.buttons.has(UIButtons.Jackpot)) {
            this.assignInterraction(
                Commands.JACKPOT_ATTENDANCE,
                this.scene.buttons.get(UIButtons.Jackpot),
                SoundVars.BUTTON_CLICK
            );
        }

        CommandManager.execute(VendorCommandsEnum.TOGGLE_SOUND_BUTTON);

        this.setBehaviours();
        this.setBonusMode();
        this.setAutoMode();
        this.setFreeSpinsMode();
        this.setPromotionBehaviours();
        this.setRespinBehaviours();
        // TODO think of having a config for that
    }

    public update(event: UIUpdateEvent, props?: any): void {
        if (this.scene) {
            switch (event) {
                case UIUpdateEvent.TempWin:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(UIComponents.Win).value =
                            SpinModel.tempWinAmount;
                    }
                    this.scene.sceneMoneyFields.get(UIComponents.WinAlternative).value =
                        SpinModel.tempWinAmount;
                    break;

                case UIUpdateEvent.Balance:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(
                            UIComponents.Balance
                        ).value = BetModel.getCurrentBalance();
                    }

                    this.scene.sceneMoneyFields.get(
                        UIComponents.BalanceAlternative
                    ).value = BetModel.getCurrentBalance();

                    if (this.autoSpinCounts) {
                        let test = AutoplayModel.autoSpinNum;
                        if (AutoplayModel.autoSpinNum >= 0) {
                            this.autoSpinCounts.text =
                                AutoplayModel.isAutoSpinActive()
                                    ? AutoplayModel.getAutoSpinNum().toString()
                                    : "0";
                        } else {
                            this.autoSpinCounts.text = '';
                        }
                    } else {
                        this.warnForMissingElement("autoSpinCounts");
                    }
                    break;
                case UIUpdateEvent.Bet:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(
                            UIComponents.TotalBet
                        ).value = BetModel.totalBet;
                    }

                    this.scene.sceneMoneyFields.get(
                        UIComponents.TotalBetAlternative
                    ).value = BetModel.totalBet;
                    break;
                case UIUpdateEvent.ClearWin:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(UIComponents.Win).value = 0;
                    }
                    this.scene.sceneMoneyFields.get(UIComponents.WinAlternative).value = 0;
                    break;
                case UIUpdateEvent.Win:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(UIComponents.Win).value =
                            props ? props.win : SpinModel.getAccumulatedWin();
                    }
                    this.scene.sceneMoneyFields.get(UIComponents.WinAlternative).value =
                        props ? props.win : SpinModel.getAccumulatedWin();
                    break;
                case UIUpdateEvent.Bangup_win:
                    let winField = this.scene.sceneMoneyFields.get(
                        UIComponents.Win
                    );
                    let bangup = new BangUp();
                    bangup.startBangup(
                        winField.value,
                        SpinModel.getAccumulatedWin(),
                        0.5,
                        {},
                        (val) => {
                            winField.value = val;
                        },
                        () => {
                            bangup = null;
                        }
                    );
                    break;
                case UIUpdateEvent.FreeGames:
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeGames
                    ).text = PromotionalFreeGamesModel.freeGamesCount
                            ? PromotionalFreeGamesModel.freeGamesCount.toString()
                            : "";
                    break;
                case UIUpdateEvent.FreeSpins:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(UIComponents.FreeSpins).value =
                        SpinModel.accumulatedWin || 0;
                    }

                    this.scene.sceneMoneyFields.get(UIComponents.FreeSpinsAlternative).value =
                        (SpinModel.accumulatedWin || 0);
                    break;
                case UIUpdateEvent.ClearFreeSpins:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(
                            UIComponents.FreeSpins
                        ).value = 0;
                    }

                    this.scene.sceneMoneyFields.get(
                        UIComponents.FreeSpinsAlternative
                    ).value = 0;
                    break;
                case UIUpdateEvent.All:
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(
                            UIComponents.Balance
                        ).value = BetModel.getCurrentBalance();
                    }

                    this.scene.sceneMoneyFields.get(
                        UIComponents.BalanceAlternative
                    ).value = BetModel.getCurrentBalance();
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(
                            UIComponents.TotalBet
                        ).value = BetModel.totalBet;
                    }

                    this.scene.sceneMoneyFields.get(
                        UIComponents.TotalBetAlternative
                    ).value = BetModel.totalBet;
                    if (!App.config.disableAltCurrency) {
                        this.scene.sceneMoneyFields.get(UIComponents.Win).value =
                            SpinModel.getCurrentWin();
                    }

                    this.scene.sceneMoneyFields.get(UIComponents.WinAlternative).value =
                        SpinModel.getCurrentWin();
                    this.autoSpinCounts.text = "";
                    this.scene.sceneTextFields.get(
                        UIComponents.FreeGames
                    ).text = PromotionalFreeGamesModel.freeGamesCount
                            ? PromotionalFreeGamesModel.freeGamesCount.toString()
                            : "";
                    break;
            }
        }
    }
    protected setFreeSpinsMode() {
        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.SoundMuted)),
            1
        );

        let isBuyFeature = false;
        if (Configs.game?.buyFeature?.isActivated) {
            isBuyFeature = true;
        } else {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.FeatureBuy)),
                1
            );
        }
        if (this.scene.buttons.has(UIButtons.Turbo)) {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToHide: [
                    ...bonusBts,
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.groups.get(UIComponents.WinInfoGroup),
                ],
                uiToDisable: [this.scene.buttons.get(UIButtons.Settings)]
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.groups.get(UIComponents.WinInfoGroup),
                    isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.Turbo)
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.Jackpot),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
                uiToEnable: GameModel.canSkipSpin()
                    ? [
                        this.scene.buttons.get(UIButtons.Stop),
                        this.scene.buttons.get(UIButtons.Sound),
                        // this.scene.buttons.get("sound_muted")
                    ]
                    : [
                        this.scene.buttons.get(UIButtons.Sound),
                        // this.scene.buttons.get("sound_muted")
                    ],
                uiToShow: [
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                ],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Settings)],
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.FREE_SPINS
        );
    }

    protected setBonusMode() {
        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)),
            1
        );
        // bonusBts.splice(
        //     bonusBts.indexOf(this.scene.buttons.get("sound_muted")),
        //     1
        // );
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToHide: [
                    ...bonusBts,
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                ],
            },
            UIModes.BONUS
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.BONUS
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.BONUS
        );
        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToHide: [...bonusBts, this.autoSpinCounts],
            },
            UIModes.BONUS
        );
    }

    protected setBehaviours() {
        let idleButtons = [...this.buttons];
        if (
            GameModel.gameConfig.disableAutoplay &&
            idleButtons.includes(this.scene.buttons.get(UIButtons.AutoPlay))
        ) {
            idleButtons.splice(
                idleButtons.indexOf(this.scene.buttons.get(UIButtons.AutoPlay)),
                1
            );
        }
        let isBuyFeature = false;
        if (Configs.game?.buyFeature?.isActivated) {
            isBuyFeature = true;
        } else {
            if (idleButtons.includes(this.scene.buttons.get(UIButtons.FeatureBuy))) {
                idleButtons.splice(
                    idleButtons.indexOf(this.scene.buttons.get(UIButtons.FeatureBuy)),
                    1
                );
            }
        }
        this.setBehaviour(UIStates.IDLE, {
            uiToEnable: idleButtons,
            uiToDisable: GameModel.gameConfig.disableAutoplay
                ? [
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ]
                : [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            uiToShow: [
                this.scene,
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.Bet),
                this.scene.groups.get(UIComponents.BetInfoGroup),
                this.scene.groups.get(UIComponents.WinInfoGroup),
                JackpotsModel.jackpotsAvailable && this.scene.buttons.get(UIButtons.Jackpot),
                this.scene.buttons.get(UIButtons.Turbo)
            ],
            uiToHide: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.Stop),
                this.scene.buttons.get(UIButtons.StopAutoplay),
                this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                isBuyFeature ? null : this.scene.buttons.get(UIButtons.FeatureBuy),
                !JackpotsModel.jackpotsAvailable && this.scene.buttons.get(UIButtons.Jackpot),
                // this.scene.groups.get(UIComponents.FreeGamesInfoGroup)
            ],
        });
        this.setBehaviour(UIStates.SPIN, {
            uiToDisable: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.Jackpot),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Turbo),
                this.scene.buttons.get(UIButtons.Bet),
                // this.scene.buttons.get("sound_muted")
            ],
            uiToEnable: GameModel.canSkipSpin()
                ? [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Sound),
                    // this.scene.buttons.get("sound_muted")
                ]
                : [
                    this.scene.buttons.get(UIButtons.Sound),
                    // this.scene.buttons.get("sound_muted")
                ],
        });
        this.setBehaviour(UIStates.SPIN_RESULT, {
            uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
            uiToEnable: GameModel.canSkipSpin()
                ? [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.Sound),
                    // this.scene.buttons.get("sound_muted")
                ]
                : [
                    this.scene.buttons.get(UIButtons.Sound),
                    // this.scene.buttons.get("sound_muted")
                ],
            uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.SPIN_END, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        this.setBehaviour(UIStates.STOP_SPIN, {
            uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
        });

        let bonusBts = [...this.buttons];
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Settings)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.Sound)),
            1
        );
        bonusBts.splice(
            bonusBts.indexOf(this.scene.buttons.get(UIButtons.SoundMuted)),
            1
        );
        if (this.scene.buttons.has(UIButtons.Turbo)) {
            bonusBts.splice(
                bonusBts.indexOf(this.scene.buttons.get(UIButtons.Turbo)),
                1
            );
        }
        this.setBehaviour(UIStates.FREE_SPINS, {
            uiToHide: [
                ...bonusBts,
                this.scene.groups.get(UIComponents.BetInfoGroup),
                this.scene.groups.get(UIComponents.WinInfoGroup),
                this.autoSpinCounts,
            ],
        });

        this.setBehaviour(UIStates.AUTO, {
            uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
            uiToShow: [
                this.autoSpinCounts,
                this.scene.buttons.get(UIButtons.StopAutoplay),
            ],
            uiToHide: [
                this.scene.buttons.get(UIButtons.Spin),
                this.scene.buttons.get(UIButtons.Stop),
            ],
            uiToDisable: [
                isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                this.scene.buttons.get(UIButtons.Settings),
                this.scene.buttons.get(UIButtons.AutoPlay),
                this.scene.buttons.get(UIButtons.Bet),
            ],
        });

        this.setBehaviour(UIStates.HIDDEN, {
            uiToHide: [this.scene],
        });
        // this.setPromotionBehaviours();
    }
    protected setAutoMode() {
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.buttons.get(UIButtons.Bet),
                    this.scene.groups.get(UIComponents.WinInfoGroup),
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                ],
            },
            UIModes.AUTO
        );
        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToShow: [
                    this.scene.groups.get(UIComponents.BetInfoGroup)],
                uiToDisable: this.buttons,
                uiToHide: [this.scene.groups.get(UIComponents.FreeSpinsInfoGroup)]
            },
            UIModes.AUTO
        );
        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToShow: [
                    this.scene.groups.get(UIComponents.WinInfoGroup),
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.buttons.get(UIButtons.Bet)
                ],
                uiToHide: [this.scene.buttons.get(UIButtons.Spin),
                this.scene.groups.get(UIComponents.FreeSpinsInfoGroup)],
                uiToEnable: [
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.scene.buttons.get(UIButtons.Sound),
                    // this.scene.buttons.get("sound_muted")
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.Bet),
                ]
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.autoSpinCounts,
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.AUTO,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.StopAutoplay)],
                uiToShow: [
                    this.autoSpinCounts,
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                ],
                uiToDisable: [
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.buttons.get(UIButtons.AutoPlay),
                    this.scene.buttons.get(UIButtons.Bet),
                ],
            },
            UIModes.AUTO
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.AUTO
        );
    }

    protected setPromotionBehaviours() {
        let isBuyFeature = false;
        if (Configs.game?.buyFeature?.isActivated) {
            isBuyFeature = true;
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.Spin)],
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: this.buttons,
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [this.scene.buttons.get(UIButtons.Spin)],
                uiToEnable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                ],
            },
            UIModes.PROMOTION_SPINS
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.PROMOTION_SPINS
        );
    }

    protected setRespinBehaviours() {
        let isBuyFeature = false;
        if (Configs.game?.buyFeature?.isActivated) {
            isBuyFeature = true;
        }
        this.setBehaviour(
            UIStates.IDLE,
            {
                uiToEnable: [this.scene.buttons.get(UIButtons.Spin)],
                uiToDisable: [this.scene.buttons.get(UIButtons.Stop)],
                uiToShow: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Settings),
                    this.scene.groups.get(UIComponents.FreeGamesInfoGroup),
                ],
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.StopAutoplay),
                    this.autoSpinCounts,
                    this.scene.groups.get(UIComponents.BetInfoGroup),
                    this.scene.groups.get(UIComponents.FreeSpinsInfoGroup),
                    isBuyFeature ? this.scene.buttons.get(UIButtons.FeatureBuy) : null,
                ],
            },
            UIModes.RESPINS
        );

        this.setBehaviour(
            UIStates.SPIN,
            {
                uiToDisable: this.buttons,
                uiToHide: [this.scene.buttons.get(UIButtons.Turbo)]
            },
            UIModes.RESPINS
        );

        this.setBehaviour(
            UIStates.SPIN_RESULT,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
            },
            UIModes.RESPINS
        );

        this.setBehaviour(
            UIStates.SPIN_END,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
            },
            UIModes.RESPINS
        );

        this.setBehaviour(
            UIStates.STOP_SPIN,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
            },
            UIModes.RESPINS
        );

        this.setBehaviour(
            UIStates.FREE_SPINS,
            {
                uiToHide: [
                    this.scene.buttons.get(UIButtons.Spin),
                    this.scene.buttons.get(UIButtons.Stop),
                    this.scene.buttons.get(UIButtons.AutoPlay)
                ],
            },
            UIModes.RESPINS
        );

        this.setBehaviour(
            UIStates.HIDDEN,
            {
                uiToHide: [this.scene],
            },
            UIModes.RESPINS
        );
    }
}
